import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {BatteryTestParams} from '../my-features/battery-test/battery-test.model';
import {CryptoService} from './crypto.service';

@Injectable({
  providedIn: 'root'
})
export class BatteryService {

  constructor(private http: HttpClient, private cryptoService: CryptoService) { }

  GetBatteryTestStatus(params: BatteryTestParams): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/battery/test/status`, params);
  }

  StartBatteryTest(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/battery/test`, params);
  }

  GetBatteryReplacementLog(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/battery/replace/read`, params);
  }
  
  GetBatteryTestScheduler(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/battery/test/scheduler/list`, params);
  }

  GetBatteryTestSchedulerDetail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/battery/test/scheduler/read`, params);
  }

  AddBatteryTestScheduler(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/battery/test/scheduler/add`, params);
  }

  UpdateBatteryTestScheduler(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/battery/test/scheduler/update`, params);
  }

  DeleteBatteryTestScheduler(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/battery/test/scheduler/delete`, params);
  }

  ReadBatteryTestSchedulerResults(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/battery/test/scheduler/exec/result/list`, params);
  }

  ExecBatteryTestScheduler(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/battery/test/scheduler/exec`, params);
  }
}
